.baseModal {
  &FooterEmpty {
    min-height: 0px !important;
    border: 0 !important;
    padding: 8px;
  }
}
